export class BulkTransferData {
	candidateId: number;
	userIds: number[];
	transferWidgetsInUnownedDashboards: boolean;
	retainEditPermission: boolean;
}
